import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=20b6d508&scoped=true&lang=pug&"
import script from "./Coupon.vue?vue&type=script&lang=js&"
export * from "./Coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6d508",
  null
  
)

export default component.exports